<template>
  <v-container fluid class="grey lighten-3" grid-list-sm>
    <v-row>
      <v-col class="font-weight-black grey text-xs-center black--text py-1">
        <h3 style="font-family: Vazir">نسخه های پازار</h3>
      </v-col>
    </v-row>
    <v-row wrap class="justify-center">
      <v-col cols="12" sm="6" md="3" pa-2 v-for="(item, idx) in items" :key="idx">
        <v-hover>
          <v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
            <v-card-title class="font-weight-black black--text justify-center" style="font-family: Vazir">{{ item.text
            }}</v-card-title>

            <v-responsive>
              <v-img :src="item.image" contain height="100px"></v-img>
            </v-responsive>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="grey darken-2" class="font-weight-thin black--text text-xs-center mb-0"
                style="font-family: Vazir" :href="item.link" target="_blank">دانلود</v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PazarVersions",
  computed: {
    items() {
      const linksData = this.$store.state.filesLinks;
      let links = {}
      // links = {
      //   autoupdatepazar: {
      //     image: require("@/assets/img/Downloads/cd-verplus.jpg"),
      //     text: "بروزرسان پازارپلاس",
      //     link: "",
      //   },
      //   pazarpluscd: {
      //     image: require("@/assets/img/Downloads/cd-verplus.jpg"),
      //     text: "نسخه کامل پازارپلاس",
      //     link: "",
      //   },
      //   pazarplussummary: {
      //     image: require("@/assets/img/Downloads/cd-verplus-summery.jpg"),
      //     text: "فایلهای اجرایی پازارپلاس",
      //     link: "",
      //   },
      //   pazarver12: {
      //     image: require("@/assets/img/Downloads/cd-ver12.jpg"),
      //     text: "پازار ۱۲",
      //     link: "",
      //   },
      // };
      // for (let index = 0; index < linksData.length; index++) {
      //   const element = linksData[index];
      //   if (element.Name.trim().toLowerCase() === "pazarver12") {
      //     links.pazarver12.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "pazarpluscd") {
      //     links.pazarpluscd.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "pazarplussummary") {
      //     links.pazarplussummary.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "autoupdatepazar") {
      //     links.autoupdatepazar.link = element.Link;
      //   }
      // }
      // --
      for (let index = 0; index < linksData.length; index++) {
        const element = linksData[index];
        if (element.CategoryId == 2) {
          links[`index${index}`] = { text: element.Caption, link: element.Link, image: element.ImageLink }
        }
      }
      // console.info(links)
      return links;
    },
  },
  // mounted: function () {
  // 	// this.getItemsLinks();
  // 	const linksData = this.$store.state.filesLinks;
  // 	for (let index = 0; index < linksData.length; index++) {
  // 		const element = linksData[index];
  // 		if (element.Name.toLowerCase() === "pazarver12") {
  // 			this.items.pazarver12.link = element.Link;
  // 		}
  // 		if (element.Name.toLowerCase() === "pazarpluscd") {
  // 			this.items.pazarpluscd.link = element.Link;
  // 		}
  // 		if (element.Name.toLowerCase() === "pazarplussummary") {
  // 			this.items.pazarplussummary.link = element.Link;
  // 		}
  // 	}
  // },
};
</script>

<style>
.text-block {
  background-color: rgba(0, 0, 0, 0.644);
}
</style>
